import { Column } from '@/components/container/Container';
import TabViewContainer from '@/components/tabs/TabViewContainer';
import { TextHeadlineExtraExtraLarge2, TextLabelMedium2 } from '@/components/text/Texts';
import { CREATE_PROGRAM } from '@/constants/button-labels';
import {
	ACTIVE_PROGRAM_TAB,
	DESCRIPTION_1,
	DESCRIPTION_2,
	HEADING,
	INACTIVE_PROGRAM_TAB,
} from '@/constants/programs-page';
import { SAMPLE_PROGRAMS } from '@/constants/sample-programs';
import { useState } from 'react';
import { MdAddCircle } from 'react-icons/md';
import TabContent from '../components/TabContent';
import AddProgramScreen from './AddProgramScreen';
import { Button } from 'primereact/button';
import { showTypedModal2 } from '@/common/common_utils';
import { useAuthenticationStore } from '@/store';
import { X4bUserRoleEnum } from '@/constants/enums';

const ProgramScreen = () => {
	const blue = 'text-primary';
	const isManager = useAuthenticationStore((state) => state.hasRoles)([X4bUserRoleEnum.Manager]);

	const [openAddModal, setOpenAddModal] = useState(false);
	const activePrograms = SAMPLE_PROGRAMS.filter((item) => item.active === true);
	const inactivePrograms = SAMPLE_PROGRAMS.filter((item) => item.active === false);
	const tabs = [
		{ tabName: ACTIVE_PROGRAM_TAB, tabContent: <TabContent programsList={activePrograms} /> },
		{ tabName: INACTIVE_PROGRAM_TAB, tabContent: <TabContent programsList={inactivePrograms} /> },
	];

	//TODO: on toggle switch program card UI must change
	return (
		<>
			<Column gap="gap-6">
				<TextHeadlineExtraExtraLarge2 text={HEADING} className="text-primary" />
				<Column>
					<TextLabelMedium2 text={DESCRIPTION_1} className="text-primary" />
					<TextLabelMedium2 text={DESCRIPTION_2} className="text-primary" />
				</Column>
				{isManager && (<Button
					label={CREATE_PROGRAM}
					icon={<MdAddCircle size={18} className="text-white" />}
					className="self-start w-auto flex"
					onClick={
						//() => setOpenAddModal(true)
						async () => {
							const res = await showTypedModal2<{}, {}>(AddProgramScreen, {});
							//if (res) setAdditionalPassengers(prev => [...prev, res]);
						}

					}
					pt={{
						root: { className: 'h-12 gap-2 pl-4 pr-6 rounded-[100px]' },
						label: { className: 'font-poppins text-label-large2 text-white' },
					}}
				/>)}
				<TabViewContainer tabList={tabs} />
			</Column>
			{/* <AddProgramScreen visible={openAddModal} onHide={() => setOpenAddModal(false)} /> */}
		</>
	);
};

export default ProgramScreen;
